export default __webpack_public_path__ + "static/rainbow-ed558df38a270cd3b22252d0d5e377bb.png";